package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.PieceJointe
import io.horion.cv.styles.PersonalFormFullWidthStyle
import io.horion.cv.styles.PersonalFormMainColumnStyle
import org.jetbrains.compose.web.css.px


@OptIn(DelicateApi::class)
@Composable
fun PieceJointeForm(
    index: Int,
    pieceJointe: PieceJointe,
    letterViewModel: LetterViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    Column(
        modifier = PersonalFormMainColumnStyle.toModifier()
    ) {
        TextFormField(
            label = "Pièce Jointe",
            value = pieceJointe.piece_jointe,
            onValueChange = {
                pieceJointe.piece_jointe = it
                letterViewModel.updatePieceJointe(index, it)
            },
            modifier = PersonalFormFullWidthStyle.toModifier()
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}